<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Minha resposta">
      <template v-slot:before>
        <v-btn class="mb-1 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading" class="text-center">
      <px-circular-loading/>
    </div>
    <div v-else>
      <px-minha-resposta-dados-basicos :solicitacao="solicitacao"/>
      <px-minha-resposta-produtos-table :solicitacao="solicitacao" :solicitacao-id="id"/>
    </div>
  </div>
</template>

<script>
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';
import MinhaRespostaDadosBasicos from './MinhaRespostaDadosBasicos.vue';
import MinhaRespostaProdutosTable from './MinhaRespostaProdutosTable.vue';

export default {
  data() {
    return {
      loading: false,
      solicitacao: null,
      id: this.$route.params.id,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  methods: {
    getSolicitacao() {
      this.loading = true;
      return SolicitacaoService.getSolicitacao(this.id)
        .then((response) => {
          this.solicitacao = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickBack() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getSolicitacao();
  },
  components: {
    pxMinhaRespostaDadosBasicos: MinhaRespostaDadosBasicos,
    pxMinhaRespostaProdutosTable: MinhaRespostaProdutosTable,
  },
};
</script>
